import type { CaptchaConfig } from '@/components/AleloCaptcha'

type CaptchaSource = {
  isCaptchaAvailable?: boolean
  captcha?: CaptchaConfig | null
  captchaProvider?: string | null
  captchaSiteKey?: string | null
  captchaImage?: string | null
} | null

export function resolveCaptcha(screen: CaptchaSource): CaptchaConfig | null {
  if (!screen) return null
  const fromObj = screen.captcha
  if (fromObj?.provider) {
    return {
      provider: fromObj.provider,
      siteKey: fromObj.siteKey ?? screen.captchaSiteKey,
      image: fromObj.image ?? screen.captchaImage,
    }
  }
  if (screen.isCaptchaAvailable || screen.captchaProvider) {
    return {
      provider: screen.captchaProvider,
      siteKey: screen.captchaSiteKey,
      image: screen.captchaImage,
    }
  }
  return null
}
